import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../components/site/Seo";
import { ChevronRight } from "lucide-react";
import NotFound from "./NotFound";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(undefined);
  useEffect(() => { setP(undefined); api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [slug]);
  useSeo({ title: p ? `${p.seo_title || p.title} | Agni Shiksha` : "Agni Shiksha", description: p?.meta_description });
  if (p === null) return <NotFound />;
  if (!p) return <div className="container-px py-40 text-center text-content-muted">Loading…</div>;
  return (
    <div className="container-px section-y max-w-3xl">
      <nav className="flex items-center gap-1.5 text-xs text-content-muted mb-6">
        <Link to="/" className="hover:text-ember">Home</Link><ChevronRight className="w-3 h-3" />
        <Link to="/blog" className="hover:text-ember">Blog</Link><ChevronRight className="w-3 h-3" />
        <span className="text-content-secondary">{p.category}</span>
      </nav>
      <span className="text-xs uppercase tracking-widest text-ember">{p.category}</span>
      <h1 className="font-heading text-3xl lg:text-4xl font-extrabold tracking-tight my-4 leading-tight">{p.title}</h1>
      <div className="text-sm text-content-muted mb-8">By {p.author}</div>
      {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full rounded-2xl border border-line mb-8 object-cover" data-testid="blog-cover" />}
      <article className="prose-invert max-w-none text-content-secondary leading-relaxed [&_h2]:font-heading [&_h2]:text-content [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-heading [&_h3]:text-content [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:mb-4 [&_img]:rounded-xl [&_img]:my-6"
        dangerouslySetInnerHTML={{ __html: p.content }} />
      {(p.related || []).length > 0 && (
        <div className="mt-14 border-t border-line pt-8">
          <h3 className="font-heading font-semibold mb-4">Related articles</h3>
          <div className="grid sm:grid-cols-3 gap-4">
            {p.related.map((r) => (
              <Link key={r.id} to={`/blog/${r.slug}`} className="card-surface p-4 hover:border-ember/60">
                <h4 className="text-sm font-medium leading-snug">{r.title}</h4>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
